module.exports = __webpack_public_path__ + "img/wizard-video.8fcb00d8.png";